import React, { useState } from 'react';
import { Toaster } from 'sonner';
import { AnimatePresence, motion } from 'framer-motion';
import { SignupState } from './components/SignupState';
import { SuccessState } from './components/SuccessState';
import { BrandMark } from './components/BrandMark';
import { PhoneMockup } from './components/PhoneMockup';
import { FlyingBird } from './components/FlyingBird';
import { CityStripe } from './components/CityStripe';
import { useScreenInit } from './useScreenInit.js';
export function App() {
  const screenInit = useScreenInit();
  const [joined, setJoined] = useState(screenInit.joined ?? false);
  const [userData, setUserData] = useState({
    name: '',
    email: ''
  });
  return <div className="min-h-screen bg-kraya-yellow text-black font-sans selection:bg-black selection:text-kraya-yellow overflow-x-hidden flex flex-col relative" data-id="element-0">
      <Toaster position="top-center" data-id="element-1" />

      <CityStripe data-id="element-2" />

      {/* Background decorative elements */}
      <div className="fixed top-20 -left-20 w-64 h-64 bg-white rounded-full opacity-20 blur-3xl pointer-events-none" data-id="element-3"></div>
      <div className="fixed bottom-20 -right-20 w-80 h-80 bg-[#FF9900] rounded-full opacity-20 blur-3xl pointer-events-none" data-id="element-4"></div>

      <header className="px-5 sm:px-8 py-6 w-full flex justify-between items-center gap-3 z-10 relative" data-id="element-5">
        <BrandMark data-id="element-6" />
        <motion.a href="https://kraya.xyz/" target="_blank" rel="noopener noreferrer" whileHover={{
        y: -2
      }} whileTap={{
        y: 1,
        scale: 0.97
      }} className="flex-shrink-0 bg-black text-white font-bold text-sm sm:text-base px-4 sm:px-5 py-2.5 rounded-full border-4 border-black neo-shadow hover:neo-shadow-lg transition-all whitespace-nowrap" data-id="element-7">
          What's Kraya? 👀
        </motion.a>
      </header>

      <main className={`flex-1 flex flex-col items-center justify-center p-6 w-full mx-auto relative z-10 min-h-[calc(100vh-100px)] ${joined ? 'max-w-2xl' : 'max-w-6xl'}`} data-id="element-8">
        <AnimatePresence mode="wait" data-id="element-9">
          {!joined ? <div key="signup" className="w-full flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-16" data-id="element-10">
              <FlyingBird data-id="element-11" />
              <div className="w-full lg:flex-1 flex justify-center" data-id="element-12">
                <SignupState onJoin={data => {
              setUserData(data);
              setJoined(true);
            }} data-id="element-13" />
              </div>
              <div className="hidden lg:flex lg:flex-1 justify-center" data-id="element-14">
                <PhoneMockup data-id="element-15" />
              </div>
            </div> : <SuccessState key="success" userData={userData} onReset={() => {
          setUserData({
            name: '',
            email: ''
          });
          setJoined(false);
        }} data-id="element-16" />}
        </AnimatePresence>
      </main>
    </div>;
}